import * as React from 'react';
import ErrorState from 'src/components/ErrorState';
import { INewsListItem } from 'src/Entities/News/NewsItem';
import { fetchNews } from 'src/helpers/api';
import Sidebar from './Sidebar';

export interface ISidebarContainerProps {
  onItemClick: (item: INewsListItem) => void;
  initialListPage: number;
  activeNewsItemId: number;
  showExpired?: boolean;
}

interface ISidebarContainerState {
  status: 'idle' | 'loading' | 'loaded' | 'error';
  news: INewsListItem[];
  page: number;
  total: number;
}

const SidebarContainer = ({
  onItemClick,
  activeNewsItemId,
  initialListPage,
  showExpired
}: ISidebarContainerProps) => {
  const [state, setState] = React.useState<ISidebarContainerState>(() => {
    return {
      status: 'idle',
      news: [],
      page: initialListPage || 0,
      total: 0
    };
  });

  const fetch = () => {
    setState({ ...state, status: 'loading' });

    fetchNews(state.page, 10, showExpired)
      .then(response => {
        const activeNewsItem = response.newsList.find(
          (item: INewsListItem) => item.id === activeNewsItemId
        );
        if (!activeNewsItem && response.newsList.length) {
          onItemClick(response.newsList[0]);
        }

        setState({
          ...state,
          status: 'loaded',
          total: response.totalPages,
          news: response.newsList
        });
      })
      .catch(() => {
        setState({ ...state, status: 'error' });
      });
  };

  React.useEffect(fetch, [state.page]);

  const handleFetchPageClick = (page: number) => {
    setState({ ...state, page });
  };

  if (state.status === 'error') {
    return (
      <div className="w-96 flex-none flex items-center justify-center">
        <ErrorState
          size="small"
          description="Nyhedslisten kunne ikke indlæses"
        />
      </div>
    );
  }

  return (
    <Sidebar
      news={state.news}
      isLoading={state.status === 'loading'}
      totalPages={state.total}
      currentPage={state.page}
      activeNewsItemId={activeNewsItemId}
      onItemClick={onItemClick}
      onFetchPageClick={handleFetchPageClick}
    />
  );
};

export default SidebarContainer;



// WEBPACK FOOTER //
// ./src/components/News/NewsModal/SidebarContainer.tsx